import { createSlice } from "@reduxjs/toolkit";
import { appRestart } from "src/duck/actions";

const initialState = {
  wizard: {
    initialStep: null
  }
};

const pairingSlice = createSlice({
  name: "pairing",
  initialState,
  reducers: {
    openWizard(state, { payload }) {
      state.wizard.initialStep = payload.initialStep;
    },
    closeWizard(state) {
      state.wizard = initialState.wizard;
    }
  },
  extraReducers(builder) {
    builder.addCase(appRestart, () => {
      return initialState;
    });
  }
});

export { pairingSlice };
export default pairingSlice.reducer;
